import ListBox from './ListBox';
import Collection from 'Support/Collection';
import SettingsForm from './Forms/SettingsForm';

export default class Settings extends ListBox {
    data() {
        return '/dashboard/profile/ajax/getSettings';
    }

    form() {
        return new SettingsForm(this.loader);
    }

    process() {
        return function (data) {
            var items = [];

            var settings = {
                weeklyTeamUpdateNotification: 'Weekly Team Status Update',
                weeklyUserUpdateNotification: 'Weekly Personal Update',
                surveyDailyDigestNotification: 'Survey Daily Digest',
                adminNotifications: 'Admin Notifications',
                pendingRepliesSummaryNotification: 'Daily Pending Responses Summary',
                reputationPage: 'Reputation Page',
                canSendSnapsForOthers: 'Enable "Choose a Team Member" App Mode',
                includeInTeamMemberLists: 'Include in Team Member Lists',
                referralSubmittedNotification: 'Referral Submissions',
                reputationBoostNotification: 'ReputationBoost℠ Notifications'
            };

            $(data.userSetting).each(function () {
                $.each(this, function (key, value) {
                    if (value && typeof settings[key] !== 'undefined') {
                        items.push(settings[key]);
                    }
                });
            });

            $(data.userSurveyNotifications).each(function () {
                if (this.positive !== 'none' || this.negative !== 'none') {
                    var item = this.surveyName + ' ';
                    if (this.positive === 'self') {
                        item += '<img src="/php/fileGenerators/glyph/svg/glyphicons-basic-238-chat-message?color=40AA40" alt="p" title="Associated positive submissions" class="settingIcon">';
                    }
                    if (this.positive === 'all') {
                        item += '<img src="/php/fileGenerators/glyph/svg/glyphicons-basic-267-comments?color=40AA40" alt="P" title="All positive submissions" class="settingIcon">';
                    }
                    if (this.negative === 'self') {
                        item += '<img src="/php/fileGenerators/glyph/svg/glyphicons-basic-238-chat-message?color=AA6060" alt="n" title="Associated negative submissions" class="settingIcon">';
                    }
                    if (this.negative === 'all') {
                        item += '<img src="/php/fileGenerators/glyph/svg/glyphicons-basic-267-comments?color=AA6060" alt="N" title="All negative submissions" class="settingIcon">';
                    }
                    items.push(item);
                }
            });

            return { title: 'Settings', items: Collection.collect(items).itemsOrNone(), disableEncoding: true };
        };
    }

    load(containerId) {
        var container = $(containerId);
        container.expandable('div.card');
        container.on('expandable.showAll.clicked', function () {
            var accessList = container.find('.accessList');
            var expandLink = $(this).find('a.expand');

            if (accessList.hasClass('expanded')) {
                accessList.removeClass('expanded');
                expandLink.html(expandLink.data('text'));
            } else {
                accessList.addClass('expanded');
                expandLink.data('text', expandLink.html());
                expandLink.html('Collapse');
            }
            return false;
        });

        super.load(containerId);
    }
}
